$(() => {
  function anchorClick(e) {
    const target = $($(this).attr('href'));

    if (target.length) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: target.offset().top
      }, 1000);
    }
  }

  function publisherInputChange() {
    const filter = latinize($(this).val().toLowerCase());
    const publisherList = $('#publisherslist');

    if (filter) {
      publisherList.find(`.publisherkeywords:not(:contains(${filter}))`).parent().hide();
      publisherList.find(`.publisherkeywords:contains(${filter})`).parent().show();
    } else {
      publisherList.find('.publishers-row').show();
    }
  }

  function publisherInputKeyup() {
    $(this).change();
  }

  $.scrollUp({
    scrollName: 'scrollUp', // Element ID
    topDistance: '300', // Distance from top before showing element (px)
    topSpeed: 300, // Speed back to top (ms)
    animation: 'fade', // Fade, slide, none
    animationInSpeed: 200, // Animation in speed (ms)
    animationOutSpeed: 200, // Animation out speed (ms)
    scrollText: __('Scroll to top'), // Text for element
    activeOverlay: false // Set CSS color to display scrollUp active point, e.g '#00FFFF'
  });

  $.each($('.publisherkeywords'), (i, val) => {
    $(val).html(latinize($(val).html()).toLowerCase());
  });

  $('a[href^="#"]').on('click', anchorClick);
  $('#publisher-name').change(publisherInputChange).keyup(publisherInputKeyup);

  $('#searchForm').submit(() => false);
});

jQuery.expr[':'].Contains = (a, i, m) => (
  (a.textContent || a.innerText || '').toUpperCase().indexOf(m[3].toUpperCase()) >= 0
);
